import { call } from 'redux-saga/effects';
import notify from '../../../helpers/notify';
import request from '../../../helpers/request';
import { UPDATE_BRIEF_COLLABORATORS } from '../constants';

const updateBriefCollaboratorsNotifier = (formValues, briefId, callback) =>
  notify({
    type: UPDATE_BRIEF_COLLABORATORS,
    callback,
    formValues,
    briefId,
  });

function* updateBriefCollaboratorsAction({ formValues, briefId, callback }) {
  yield call(request, {
    type: UPDATE_BRIEF_COLLABORATORS,
    callback,
    method: 'put',
    endpoint: `/briefs/${briefId}/collaborators`,
    params: formValues,
  });
}

export { updateBriefCollaboratorsAction, updateBriefCollaboratorsNotifier };
